import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UpdateDataTokenCode } from '../class/update-data';
import { DataForm } from '../interfaces/data';
import {
  Promoter,
  StepOCRDaeResponse,
  StepOCRLtoResponse,
} from '../interfaces/step-data';

@Injectable({
  providedIn: 'root',
})
export class RequestFormService {
  private dataFormSubject = new Subject<DataForm>();
  private dataForm: DataForm = { email: '', requestNumber: '' };

  // stepper data update
  private updateFormSubject = new Subject<UpdateDataTokenCode>();
  private updateForm!: UpdateDataTokenCode;

  private dataFormMoreInformationOCRSubject = new Subject<StepOCRDaeResponse>();
  private dataFormMoreInformationOCR!: StepOCRDaeResponse;

  private dataFormMoreInformationOCRLtoSubject =
    new Subject<StepOCRLtoResponse>();
  private dataFormMoreInformationOCRLto!: StepOCRLtoResponse;

  private dataPromoterSubject = new Subject<Promoter>();
  private dataPromoter!: Promoter;

  // constructor() {
  //   const updateFormData = sessionStorage.getItem('update-form-data');
  //   if (updateFormData) {
  //     this.updateForm = JSON.parse(updateFormData);
  //   }
  // }

  // devuelve datos email y num requerimiento
  setDataForm(change: DataForm) {
    this.dataFormSubject.next(change);
    this.dataForm = change;
  }

  getDataForm() {
    return this.dataForm;
  }

  getDataFormObservable() {
    return this.dataFormSubject.asObservable();
  }

  // devuelve datos de los formularios ya guardados
  setUpdateForm(change: UpdateDataTokenCode) {
    this.updateFormSubject.next(change);
    this.updateForm = change;
    // sessionStorage.setItem('update-form-data', JSON.stringify(change));
  }

  getUpdateForm() {
    return this.updateForm;
  }

  getUpdateFormObservable() {
    return this.updateFormSubject.asObservable();
  }

  //datos obtenidos del response OCR DAE
  setDataDocumentsOCR(change: StepOCRDaeResponse) {
    this.dataFormMoreInformationOCRSubject.next(change);
    this.dataFormMoreInformationOCR = change;
  }

  getDataDocumentsOCR() {
    return this.dataFormMoreInformationOCR;
  }

  getDataDocumentsOCRObservable() {
    return this.dataFormMoreInformationOCRSubject.asObservable();
  }
  //datos obtenidos del response OCR LTO
  setDataDocumentsOCRLTO(change: StepOCRLtoResponse) {
    this.dataFormMoreInformationOCRLtoSubject.next(change);
    this.dataFormMoreInformationOCRLto = change;
  }

  getDataDocumentsOCRLTO() {
    return this.dataFormMoreInformationOCRLto;
  }

  getDataDocumentsOCRObservableLTO() {
    return this.dataFormMoreInformationOCRLtoSubject.asObservable();
  }
  //datos del promotor
  setDataPromoterLTO(change: Promoter) {
    this.dataPromoterSubject.next(change);
    this.dataPromoter = change;
  }

  getDataPromoterLTO() {
    return this.dataPromoter;
  }

  getDataPromoterObservableLTO() {
    return this.dataPromoterSubject.asObservable();
  }
}
